import { FC, ReactElement } from 'react'
import SvgIcon from 'components/atoms/SvgIcon'
import BackgroundSvg from 'icons/crypto_buy_portal.svg?skip-svgo'

import styles from 'components/features/rewards/rewardsPane/components/CryptoRewardsSuccessInvestmentImagePreset/CryptoRewardsSuccessInvestmentImagePreset.styl'

export const CryptoRewardsSuccessInvestmentImagePreset: FC = ({ children }): ReactElement => {
  const backgroundImage = <SvgIcon src={ BackgroundSvg } useDefaultViewBox />

  return (
    <div className={ styles.successIconWrapper }>
      <div className={ styles.currencyLogoWrapper }>
        { children }
      </div>
      { backgroundImage }
    </div>)

}
